{
  "page_title": "Lisäpalvelut",
  "calendar": {
    "make_booking": "Tee varaus",
    "service": "Palvelu",
    "inactive": "Ei käytössä",
    "no_units": "Ei palveluita",
    "failed_to_load": "Kalenterin lataaminen epäonnistui",
    "prev_day": "Edellinen päivä",
    "next_day": "Seuraava päivä",
    "prev_week": "Edellinen viikko",
    "next_week": "Seuraava viikko",
    "view_mode_label": "Kalenterinäkymä",
    "view_day": "Päivä",
    "view_week": "Viikko",
    "pick_date": "Valitse päivämäärä",
    "show_day": "Näytä päivänäkymä",
    "margin": "Varausmarginaali",
    "collapse_panel": "Pienennä paneeli",
    "expand_panel": "Laajenna paneeli",
    "show_group": "Näytä {{name}}",
    "hide_group": "Piilota {{name}}",
    "booking": {
      "title": "Uusi varaus",
      "mode_label": "Varaustapa",
      "single_tab": "Yksittäinen varaus",
      "batch_tab": "Massavaraus",
      "type_label": "Varaustyyppi",
      "type": {
        "service": "Huolto",
        "competition": "Kilpailu",
        "tee_time": "Tiiaika",
        "other": "Muu"
      },
      "group_label": "Palveluryhmä",
      "unit_label": "Palvelu",
      "unit_placeholder_single": "Valitse palvelu",
      "unit_placeholder_batch": "Valitse palvelut",
      "selected_count": "{{count}} / {{total}} valittu",
      "select_all_free": "Valitse kaikki vapaat",
      "no_units": "Ei palveluita",
      "status_free": "Vapaa",
      "status_busy": "Varattu",
      "start": "Alkaa",
      "end": "Päättyy",
      "duration_label": "Kesto",
      "holes9": "9 reikää ({{min}} min)",
      "holes18": "18 reikää ({{min}} min)",
      "notes": "Lisätiedot",
      "notes_placeholder": "Esim. asiakkaan nimi",
      "submit": "Tee varaus",
      "created": "Varaus luotu",
      "save_failed": "Varauksen tallennus epäonnistui",
      "availability_failed": "Saatavuuden lataaminen epäonnistui",
      "times_required": "Valitse alku- ja loppuaika",
      "invalid_window": "Loppuajan on oltava alkuajan jälkeen",
      "type_required": "Valitse varaustyyppi",
      "unit_required": "Valitse palvelu",
      "units_required": "Valitse vähintään yksi palvelu",
      "conflict_row": "{{unit}}: {{start}}–{{end}}",
      "overlap_warning": "Varaus menee päällekkäin olemassa olevan varauksen kanssa."
    },
    "reservation": {
      "edit": "Muokkaa",
      "edit_title": "Muokkaa varausta",
      "updated": "Varaus päivitetty",
      "update_failed": "Varauksen päivitys epäonnistui",
      "delete": "Poista",
      "delete_confirm_header": "Poista varaus",
      "delete_confirm_body": "Haluatko varmasti poistaa varauksen {{name}}?",
      "delete_scope_single": "Vain tämä varaus",
      "delete_scope_batch": "Kaikki tämän erän varaukset",
      "deleted": "Varaus poistettu",
      "batch_deleted": "Erän varaukset poistettu",
      "delete_failed": "Varauksen poistaminen epäonnistui"
    },
    "resize": {
      "saved": "{{unit}}: varauksen aikaa muutettu",
      "undo_failed": "Kumoaminen epäonnistui"
    }
  },
  "serviceGroups": {
    "panel_title": "Palveluryhmät",
    "empty": {
      "heading": "Ei palveluryhmiä",
      "description": "Palveluryhmillä hallitset vuokrattavia lisäpalveluita, kuten golfautoja, bageja ja kärryjä.",
      "add_button": "Lisää palveluryhmä"
    },
    "add_group_short": "Ryhmä",
    "failed_to_load": "Palveluryhmien lataaminen epäonnistui",
    "activate": "Ota käyttöön {{name}}",
    "deactivate": "Poista käytöstä {{name}}",
    "list": {
      "name": "Nimi",
      "active": "Aktiivinen",
      "yes": "Kyllä",
      "no": "Ei"
    },
    "card": {
      "actions_aria": "Palveluryhmän {{name}} toiminnot",
      "in_use": "Käytössä",
      "yes": "Kyllä",
      "no": "Ei",
      "duration": "Kesto",
      "margin": "Marginaali",
      "holes9": "9r",
      "holes18": "18r",
      "before": "ennen",
      "after": "jälkeen",
      "min": "min"
    },
    "form": {
      "create_title": "Uusi palveluryhmä",
      "edit_title": "Muokkaa palveluryhmää",
      "section_title": "Palveluryhmän asetukset",
      "name": "Nimi",
      "icon": "Ryhmän ikoni",
      "icons": {
        "carFront": "Auto",
        "bicycle": "Polkupyörä",
        "gear": "Ratas",
        "star": "Tähti",
        "person": "Henkilö"
      },
      "active": "Käytössä",
      "duration9": "Varauksen kesto 9 reikää (min)",
      "duration18": "Varauksen kesto 18 reikää (min)",
      "margin_before": "Varausmarginaali ennen varausta (min)",
      "margin_after": "Varausmarginaali varauksen jälkeen (min)",
      "terms": "Varausehdot (näytetään pelaajalle varausta tehdessä)",
      "name_required": "Nimi on pakollinen",
      "created": "Palveluryhmä luotu",
      "updated": "Palveluryhmä päivitetty",
      "deleted": "Palveluryhmä poistettu",
      "load_failed": "Palveluryhmän lataaminen epäonnistui",
      "save_failed": "Tallennus epäonnistui",
      "delete_failed": "Poisto epäonnistui",
      "delete_confirm_header": "Poista palveluryhmä",
      "delete_confirm_body": "Haluatko varmasti poistaa palveluryhmän {{name}}?"
    },
    "units": {
      "section_title": "Palvelut",
      "add_button": "Lisää palvelu",
      "name": "Nimi",
      "active": "Käytössä",
      "reservations": "Varaukset",
      "reservations_title": "{{count}} tulevaa varausta",
      "name_placeholder": "Palvelun nimi",
      "save": "Tallenna",
      "empty": "Ei palveluita",
      "created": "Palvelu luotu",
      "updated": "Palvelu päivitetty",
      "activated": "{{name}} otettu käyttöön",
      "deactivated": "{{name}} poistettu käytöstä",
      "deleted": "Palvelu poistettu",
      "name_required": "Palvelun nimi on pakollinen",
      "load_failed": "Palveluiden lataaminen epäonnistui",
      "save_failed": "Palvelun tallennus epäonnistui",
      "delete_failed": "Palvelun poisto epäonnistui",
      "delete_confirm_header": "Poista palvelu",
      "delete_confirm_body": "Haluatko varmasti poistaa palvelun {{name}}?",
      "form": {
        "create_title": "Uusi palvelu",
        "edit_title": "Muokkaa palvelua"
      }
    }
  }
}
